import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const RoundIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      id='Capa_1' fill={theme.palette.text.primary} enableBackground='new 0 0 512.497 512.497' height={props.width}
      viewBox='0 0 512.497 512.497' width={props.width} xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          d='m73.208 198.877c18.753-59.701 65.967-106.916 125.669-125.669l-31.735-31.735c-9.809-9.809-22.849-15.21-36.721-15.21-5.348 0-10.57.811-15.534 2.36 4.744 23.255-1.871 48.388-19.874 66.39-13.804 13.804-32.157 21.406-51.679 21.406-5.005 0-9.932-.508-14.727-1.484-1.539 4.949-2.344 10.155-2.344 15.485 0 13.871 5.402 26.912 15.21 36.721z'
        />
        <path
          d='m382.075 26.263c-13.872 0-26.912 5.401-36.721 15.21l-31.734 31.735c59.702 18.753 106.916 65.968 125.669 125.669l31.735-31.735c9.808-9.809 15.21-22.85 15.21-36.721 0-5.331-.805-10.536-2.344-15.485-4.795.976-9.721 1.484-14.727 1.484-19.522 0-37.875-7.602-51.679-21.406-18.003-18.003-24.618-43.135-19.874-66.39-4.964-1.55-10.186-2.361-15.535-2.361z'
        />
        <path
          d='m130.421 486.234c13.872 0 26.912-5.401 36.721-15.21l31.735-31.735c-59.702-18.753-106.916-65.967-125.669-125.669l-31.735 31.735c-9.808 9.809-15.21 22.85-15.21 36.721 0 5.331.805 10.536 2.344 15.485 4.795-.976 9.721-1.484 14.727-1.484 19.522 0 37.875 7.602 51.679 21.406s21.406 32.157 21.406 51.679c0 5.006-.508 9.932-1.484 14.727 4.95 1.54 10.155 2.345 15.486 2.345z'
        />
        <path
          d='m382.075 486.234c5.331 0 10.536-.805 15.485-2.344-.976-4.795-1.484-9.721-1.484-14.727 0-19.522 7.602-37.875 21.406-51.679s32.157-21.406 51.679-21.406c5.005 0 9.932.508 14.727 1.484 1.539-4.949 2.344-10.155 2.344-15.485 0-13.871-5.402-26.912-15.21-36.721l-31.735-31.734c-18.753 59.701-65.967 106.915-125.669 125.668l31.735 31.735c9.81 9.807 22.851 15.209 36.722 15.209z'
        />
        <path d='m43.334 86.42c56.615-.912 56.604-85.269-.002-86.171-56.613.911-56.602 85.269.002 86.171z' />
        <path
          d='m438.696 73.8c41.203 39.162 100.092-19.745 60.931-60.933-41.202-39.161-100.09 19.746-60.931 60.933z'
        />
        <path
          d='m499.629 438.697c-41.203-39.163-100.092 19.745-60.931 60.933 41.202 39.161 100.09-19.746 60.931-60.933z'
        />
        <path
          d='m73.8 438.697c-41.203-39.163-100.092 19.745-60.931 60.933 41.202 39.161 100.09-19.746 60.931-60.933z'
        />
        <circle cx='256.248' cy='256.249' r='161.808' />
      </g>
    </svg>
  )
}
export default RoundIcon
